import React from 'react';
import { useTranslation } from 'react-i18next';
import {
    NLP_DETAIL_SCORE_COLUMNS,
    renderDetailRow,
} from '../TracePanelShared';

const scoreAverage = (value) => {
  if (value || value === 0) {
    return Number(value).toLocaleString(undefined, {
      style: 'percent',
      minimumFractionDigits: 2
    });
  } else {
    return 'unknown';
  }
};

const renderEntity = (entity, index, entitiesLabel, scoresLabel) => {
  return (
    <React.Fragment key={`${entity.entity}-${entity.value}-${index}`}>
      {index === 0 && renderDetailRow({
        content: `${entitiesLabel}:`,
        trailing: <span>{scoresLabel}:</span>,
        alignItems: 'flex-end',
      })}
      {renderDetailRow({
        content: `@${entity.entity}: ${entity.value}`,
        trailing: scoreAverage(entity.score),
        alignItems: 'flex-end',
      })}
    </React.Fragment>
  );
};

const ConversationItemEntities = (props) => {
  const { t } = useTranslation();
  const entitiesLabel = t('Entities');
  const scoresLabel = t('Scores');

  return (
    <React.Fragment>
      {props.entities ? (
        props.entities.map((entity, index) => {
          return renderEntity(entity, index, entitiesLabel, scoresLabel);
        })
      ) : (
        renderDetailRow({
          content: t('No entities'),
          trailingColumns: NLP_DETAIL_SCORE_COLUMNS,
          alignItems: 'flex-end',
        })
      )}
    </React.Fragment>
  );
};

export default ConversationItemEntities;
